import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Privacidad() {
  const navigate = useNavigate();
  const updated = '1 de marzo de 2026';

  useEffect(() => {
    const html = document.documentElement;
    const prev = html.className;
    html.classList.add('dark');
    return () => { html.className = prev; };
  }, []);

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <nav className="border-b border-white/5 px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <img
            src="/logorentiacompletonaranjablanco.png"
            alt="Rentia"
            className="h-8 w-auto object-contain cursor-pointer"
            onClick={() => navigate('/')}
          />
          <button onClick={() => navigate(-1)} className="text-gray-400 hover:text-white text-sm transition-colors">
            ← Volver
          </button>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold mb-2">Política de Privacidad</h1>
        <p className="text-gray-400 text-sm mb-12">Última actualización: {updated}</p>

        <div className="space-y-10 leading-relaxed">

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">1. Responsable del tratamiento</h2>
            <p>
              Rentia, disponible en <span className="text-[#ed6f28]">rentiapropiedades.com</span>, es responsable del
              tratamiento de los datos personales recopilados a través de su plataforma, en cumplimiento de la
              Ley N° 25.326 de Protección de Datos Personales de la República Argentina y sus normas reglamentarias.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">2. Datos que recopilamos</h2>
            <p>Recopilamos únicamente los datos necesarios para prestar el servicio:</p>
            <ul className="list-disc list-inside mt-3 space-y-1 text-white">
              <li><strong className="text-gray-100">Datos de cuenta:</strong> nombre, dirección de correo electrónico y contraseña (almacenada con hash bcrypt).</li>
              <li><strong className="text-gray-100">Datos de uso:</strong> registros de acceso (fecha y hora del último ingreso), sección utilizada.</li>
              <li><strong className="text-gray-100">Datos de inquilinos y contratos:</strong> información que el propio usuario carga en la plataforma (nombres, DNI, domicilios, montos, fechas).</li>
              <li><strong className="text-gray-100">Datos de facturación:</strong> historial de planes y pagos asociados a la cuenta.</li>
              <li><strong className="text-gray-100">Archivos adjuntos:</strong> imágenes y documentos cargados (boletas, logos), almacenados en nuestra base de datos.</li>
            </ul>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">3. Finalidad del tratamiento</h2>
            <p>Los datos recopilados se utilizan exclusivamente para:</p>
            <ul className="list-disc list-inside mt-3 space-y-1 text-white">
              <li>Proveer y mantener el servicio de gestión de propiedades.</li>
              <li>Gestionar la autenticación y seguridad de la cuenta.</li>
              <li>Enviar notificaciones relacionadas con el servicio (vencimientos, actualizaciones de precios).</li>
              <li>Cumplir con obligaciones legales aplicables.</li>
            </ul>
            <p className="mt-3">
              No utilizamos los datos para publicidad de terceros ni los cedemos a empresas de marketing.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">4. Almacenamiento y seguridad</h2>
            <p>
              Los datos se almacenan en servidores con cifrado en tránsito (TLS/HTTPS) y en reposo.
              Las contraseñas nunca se almacenan en texto plano; se aplica el algoritmo bcrypt con factor de costo 12.
              Los tokens de sesión son JWT con vencimiento de 24 horas.
            </p>
            <p className="mt-3">
              Implementamos medidas técnicas y organizativas razonables para proteger la información contra
              acceso no autorizado, pérdida o alteración. Sin embargo, ningún sistema es completamente infalible,
              por lo que no podemos garantizar seguridad absoluta.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">5. Datos de terceros (inquilinos)</h2>
            <p>
              Al cargar datos de inquilinos u otras personas en la plataforma, el usuario declara contar con
              la autorización necesaria para su tratamiento y asume la responsabilidad sobre dicha información.
              Rentia actúa como encargado del tratamiento en relación con esos datos y no los utiliza para
              ninguna finalidad propia.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">6. Comunicaciones por correo electrónico</h2>
            <p>
              Enviamos correos relacionados estrictamente con el servicio: verificación de cuenta, recuperación
              de contraseña, avisos de vencimiento de suscripción y actualizaciones importantes de la plataforma.
              No realizamos envíos promocionales sin consentimiento explícito del usuario.
            </p>
            <p className="mt-3">
              Si el usuario configura una cuenta de correo propia para el envío de recibos, las credenciales
              ingresadas (contraseña de aplicación) se almacenan cifradas y se usan únicamente para ese fin.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">7. Compartición de datos</h2>
            <p>No vendemos ni cedemos datos personales a terceros, salvo en los siguientes casos:</p>
            <ul className="list-disc list-inside mt-3 space-y-1 text-white">
              <li><strong className="text-gray-100">Proveedores de infraestructura:</strong> los servicios de hosting y base de datos pueden procesar datos en nombre de Rentia bajo acuerdos de confidencialidad.</li>
              <li><strong className="text-gray-100">Requerimiento legal:</strong> cuando sea exigido por una autoridad competente conforme a la legislación argentina vigente.</li>
            </ul>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">8. Derechos del titular</h2>
            <p>
              De conformidad con la Ley N° 25.326, el titular de los datos tiene derecho a acceder, rectificar,
              actualizar o suprimir su información personal. Para ejercer estos derechos, puede escribir a:{' '}
              <a href="mailto:soporte@rentiapropiedades.com" className="text-[#ed6f28] hover:underline">
                soporte@rentiapropiedades.com
              </a>{' '}
              indicando el derecho que desea ejercer.
            </p>
            <p className="mt-3">
              La DIRECCIÓN NACIONAL DE PROTECCIÓN DE DATOS PERSONALES es el organismo de control competente
              para recibir denuncias y reclamos en la materia.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">9. Retención de datos</h2>
            <p>
              Los datos de cuenta se conservan mientras la cuenta esté activa. Tras la cancelación o baja
              definitiva del servicio, los datos se eliminan dentro de los 90 días corridos, salvo que exista
              una obligación legal de conservación.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">10. Cookies y rastreo</h2>
            <p>
              Rentia no utiliza cookies de rastreo ni herramientas de análisis de comportamiento de terceros
              (Google Analytics, Meta Pixel, etc.). El almacenamiento local del navegador (localStorage) se
              utiliza exclusivamente para mantener la sesión del usuario autenticado.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">11. Modificaciones a esta política</h2>
            <p>
              Esta Política de Privacidad puede actualizarse periódicamente. Notificaremos los cambios
              significativos por correo electrónico o mediante un aviso visible en la plataforma. La fecha
              de última actualización se indica al inicio de este documento.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">12. Contacto</h2>
            <p>
              Para consultas relacionadas con esta Política de Privacidad o el tratamiento de sus datos, puede
              comunicarse a:{' '}
              <a href="mailto:soporte@rentiapropiedades.com" className="text-[#ed6f28] hover:underline">
                soporte@rentiapropiedades.com
              </a>
            </p>
          </section>

        </div>
      </main>

      <footer className="border-t border-white/5 px-6 py-6 text-center text-gray-600 text-xs">
        © {new Date().getFullYear()} Rentia · Todos los derechos reservados
      </footer>
    </div>
  );
}
